<div class="classification-history">
  <mat-progress-bar
    *ngIf="isLoadingEmail"
    mode="indeterminate"
    [ngClass]="'classification-history__progress-bar'"
  ></mat-progress-bar>
  <div class="classification-history__classifier">
    <div
      class="classification-history__table-container"
      id="table-container"
    >
      <app-table
        [columnHeaders]="columnHeaders"
        [displayedColumns]="displayedColumns"
        [data]="classifiedEmails"
        [totalItems]="total"
        [pageSize]="pageSize"
        [loading]="isLoadingClassifiedEmails"
        [selectionMode]="selectionMode"
        (pageChange)="onPageChange($event)"
        (selectedChange)="onSelectedChange($event)"
        (refresh)="onRefresh()"
        class="classification-history__table"
      >
      </app-table>
    </div>
    <ng-container *ngIf="currentMessage && !isLoadingClassifiedEmails; else NoLogs">
      <app-mail-classifier-details-body
        [elementsToCalculateHeight]="elementsToCalculateHeight"
      ></app-mail-classifier-details-body>
    </ng-container>
    <ng-template #NoLogs>
      <div class="classification-history__empty-data-message">
        <img
          src="/assets/images/no_data_found.avif"
          alt="not-found"
          height="500"
        />
      </div>
    </ng-template>
  </div>
  <div class="classification-history__interactions-classifications-container">
    <div class="classification-history__classifications-status-container">
      <app-mail-classification></app-mail-classification>
    </div>
    <div class="classification-history__search-leads">
      <app-mail-classifier-search-leads></app-mail-classifier-search-leads>
    </div>
  </div>
</div>
